import * as React from 'react';
import * as autoBind from 'react-autobind';
import TextareaAutosize from 'react-autosize-textarea';
import Constants from '../../globals/Constants';

const UNREASONABLY_HIGH_NUMBER = 99999999999;

export default class TextAreaWrapper extends React.Component<TextAreaWrapperProps, {}> {
   static defaultProps: Partial<TextAreaWrapperProps> = {
      onEnter: () => null,
      onChange: () => null,
      onEscape: () => null,
      placeholder: '',
      id: '',
      readOnly: false
   };

   textAreaRef: HTMLTextAreaElement;

   constructor(props: TextAreaWrapperProps) {
      super(props);
      autoBind(this);
   }

   setTextAreaRef(textAreaRef: HTMLTextAreaElement) {
      this.textAreaRef = textAreaRef;
   }

   handleIECursorPlacement(e: any): void {
      const {onFocus} = this.props;
      const input = e.target;
      if (input.setSelectionRange) {
         input.setSelectionRange(UNREASONABLY_HIGH_NUMBER, UNREASONABLY_HIGH_NUMBER);
      } else {
         input.value = input.value;
      }

      if (onFocus) {
         onFocus();
      }
   }

   handleKeyDown(e: any): void {
      const {onEnter, onEscape} = this.props;
      if (e.keyCode === Constants.keys.enter && !e.shiftKey) {
         onEnter();
         e.preventDefault();
      } else if (e.keyCode === Constants.keys.escape) {
         onEscape();
      }
   }

   componentDidMount() {
      this.textAreaRef.scrollTop = this.textAreaRef.scrollHeight;
      if (this.props.hasFocus) {
         this.textAreaRef.focus();
      }
   }

   componentDidUpdate(prevProps: TextAreaWrapperProps) {
      if (!prevProps.hasFocus && this.props.hasFocus) {
         this.textAreaRef.focus();
      }
   }

   onChange(e: any): void {
      this.props.onChange(e.target.value);
   }

   render() {
      const {className, readOnly, placeholder, text, maxRows, onBlur, autoFocus, id} = this.props;
      return (
      <React.Fragment>
         <label className="screen-reader-only" id="comment-input-label">{placeholder}</label>
         <TextareaAutosize id={id} value={text} placeholder={placeholder} onChange={this.onChange} autoFocus={autoFocus} ref={this.setTextAreaRef} readOnly={readOnly} className={className} onFocus={this.handleIECursorPlacement} onBlur={onBlur} onKeyDown={this.handleKeyDown} maxRows={maxRows} aria-labelledby="comment-input-label"/>
      </React.Fragment>
      );
   }
}

interface TextAreaWrapperProps {
   text: string;
   placeholder?: string;
   readOnly?: boolean;
   autoFocus: boolean;
   className?: string;
   hasFocus?: boolean;
   maxRows?: number;
   id?: string;
   onChange?(text: string): void;
   onEscape?(): void;
   onEnter?(): void;
   onBlur?(): void;
   onFocus?(): void;
}
